import { useState, useRef, useEffect } from 'react';
import { Search, ChevronDown } from 'lucide-react';

const VIEW_BY_OPTIONS = ['Department', 'Tenants'];

export default function SearchFilter({
  showFilterButton = true,
  showViewBy = false,
  onViewByChange,
}) {
  const [viewBy, setViewBy] = useState('Department');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="flex items-center justify-between mb-6 py-2">
      <div className="flex items-center gap-[24px]">
        {/* Input */}
        <div className="relative flex items-center w-[400px] h-10 px-2 py-1 bg-[#EDEDED] rounded-lg">
          <Search className="w-5 h-5 text-[#7B7B7B] mr-2 flex-shrink-0" />
          <input
            type="text"
            placeholder="Search"
            className="flex-1 bg-transparent outline-none ring-0 border-none text-sm text-[#7B7B7B] placeholder-[#A8A8A8] focus:outline-none focus:ring-0"
          />
        </div>

        {/* Search button */}
        <button className="flex items-center justify-center gap-2 h-10 px-4 bg-[#0088FF] text-white text-base font-medium rounded-lg hover:bg-[#0070DD] transition-colors">
          <Search className="w-4 h-4" />
          Search
        </button>
      </div>

      <div className="flex items-center gap-3">
        {/* All filter button */}
        {showFilterButton && (
          <button className="flex items-center gap-2 px-[13px] py-2 bg-[#EDEDED] rounded-lg hover:bg-[#E0E0E0] transition-colors">
            <span className="text-base text-[#1D2739]">All</span>
            <ChevronDown className="w-4 h-4 text-[#000000]" />
          </button>
        )}

        {/* View by dropdown */}
        {showViewBy && (
          <div className="relative" ref={dropdownRef}>
            <button
              onClick={() => setDropdownOpen((o) => !o)}
              className="flex items-center gap-2 px-[13px] py-2 bg-[#0088FF]/[0.08] rounded-lg hover:bg-[#0088FF]/[0.15] transition-colors"
            >
              <span className="text-base text-[#0088FF] font-medium">
                View by: {viewBy}
              </span>
              {/* <ChevronDown className="w-4 h-4 text-[#0088FF]" /> */}
            </button>

            {dropdownOpen && (
              <div className="absolute right-0 mt-1 w-40 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
                {VIEW_BY_OPTIONS.map((option) => (
                  <button
                    key={option}
                    onClick={() => {
                      setViewBy(option);
                      setDropdownOpen(false);
                      onViewByChange?.(option);
                    }}
                    className={`w-full text-left px-4 py-2 text-sm hover:bg-gray-50 first:rounded-t-lg last:rounded-b-lg transition-colors
                      ${viewBy === option ? 'text-[#0088FF] font-medium' : 'text-[#1D2739]'}`}
                  >
                    {option}
                  </button>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
